







































































































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { ConsultaColetiva } from '../../../../back/src/entity/ConsultaColetiva';
import { ConsultaColetivaPostFormData, ConsultaColetivaPutFormData } from '../../../../back/src/types';

import PacienteConsultaColetivaMiniCard from '../pacientes/PacienteConsultaColetivaMiniCard.vue';
import ThePacientesObservacoesAlert from '../pacientes/ThePacientesObservacoesAlert.vue';
import ThePacientesResumo from '../pacientes/ThePacientesResumo.vue';
import CustomDialog from '../CustomDialog.vue';

export default Vue.extend({
  name: 'TheConsultasColetivasCriarAlterarDialog',
  components: {
    PacienteConsultaColetivaMiniCard,
    ThePacientesObservacoesAlert,
    ThePacientesResumo,
    CustomDialog,
  },
  data() {
    return {
      dialogResumoPaciente: false,
      dialog: false,
      loading: false,
      menuDataInicio: false,
      menuDataFim: false,
      pacientes: [] as Paciente[],
      pacientesSelecionadas: [] as Paciente[],
      pacienteSelecionada: {} as Paciente,
      form: {
        id: null,
        dataInicio: '',
        horaInicio: '',
        dataFim: '',
        horaFim: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
        arrayRequired: [
          (v: any[]) => v.length > 0 || 'Selecione as participantes',
        ],
        hora: [
          (v: string) => !!v || 'Campo obrigatório',
          (v: string) => {
            const timePattern: RegExp = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
            return (v && timePattern.test(v)) || 'Horário inválido';
          },
        ],
      },
    };
  },
  computed: {
    tituloDialog() {
      return this.form.id === null ? 'Agendar coletiva' : 'Alterar coletiva';
    },
    textoBotaoSubmit() {
      return this.form.id === null ? 'Agendar' : 'Alterar';
    },
    inputDataInicio() {
      return this.form.dataInicio;
    },
    inputHoraInicio() {
      return this.form.horaInicio;
    },
    dataInicioFormatada(): string {
      if (this.form.dataInicio) {
        const momentData = moment(this.form.dataInicio);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataFimFormatada(): string {
      if (this.form.dataFim) {
        const momentData = moment(this.form.dataFim);
        if (momentData.isValid()) {
          return momentData.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    formConsultaColetiva(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formConsultaColetiva as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean,
      };
    },
  },
  methods: {
    async abrirDialog(consultaColetiva: ConsultaColetiva) {
      this.dialog = true;
      await this.getPacientes();
      if (consultaColetiva !== null) {
        this.form.id = consultaColetiva.id;
        this.form.dataInicio = moment(consultaColetiva.datetime_agendamento).format('YYYY-MM-DD');
        this.form.horaInicio = moment(consultaColetiva.datetime_agendamento).format('HH:mm');
        this.form.dataFim = moment(consultaColetiva.datetime_agendamento_fim).format('YYYY-MM-DD');
        this.form.horaFim = moment(consultaColetiva.datetime_agendamento_fim).format('HH:mm');
        this.pacientesSelecionadas = _.map(
          consultaColetiva.consultas,
          consulta => consulta.paciente,
        );
      }
    },
    async getPacientes(): Promise<void> {
      this.loading = true;
      try {
        const response = await Requester.paciente.pacientesGestantes();
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.pacientes = response.data;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
      }
    },
    removePacienteSelecionada(pacienteId) {
      const index = _.findIndex(this.pacientesSelecionadas as Paciente[],
        paciente => paciente.id === pacienteId);
      if (index >= 0) this.pacientesSelecionadas.splice(index, 1);
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formConsultaColetiva.validate()) {
        this.loading = false;
        return;
      }
      const consultas = _.map(
        this.pacientesSelecionadas as Paciente[],
        (paciente: Paciente) => {
          const novaConsulta = {
            paciente_id: paciente.id as number,
            gestacao_id: paciente.gestacao_atual && paciente.gestacao_atual.id
              ? paciente.gestacao_atual.id
              : null,
          };
          return novaConsulta;
        },
      );
      if (this.form.id !== null) {
        // EDICAO
        const formData: ConsultaColetivaPutFormData = {
          id: this.form.id,
          datetime_agendamento: moment(`${this.form.dataInicio} ${this.form.horaInicio}`).toDate(),
          datetime_agendamento_fim: moment(`${this.form.dataFim} ${this.form.horaFim}`).toDate(),
          consultas,
        };
        try {
          const response = await Requester.consultaColetiva.alteraConsultaColetiva(formData);
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          } else {
            this.fechaDialogLimpaForm();
            this.$emit('busca-consultas-coletivas');
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Consulta coletiva alterada com sucesso!' });
          }
        } catch (err) {
          this.$root.$emit('requestError', err);
        } finally {
          this.loading = false;
        }
      } else {
        // CRIACAO
        const formData: ConsultaColetivaPostFormData = {
          datetime_agendamento: moment(`${this.form.dataInicio} ${this.form.horaInicio}`).toDate(),
          datetime_agendamento_fim: moment(`${this.form.dataFim} ${this.form.horaFim}`).toDate(),
          consultas,
        };
        try {
          const response = await Requester.consultaColetiva.criaConsultaColetiva(formData);
          if (response.errors.length > 0) {
            this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
          } else {
            this.fechaDialogLimpaForm();
            this.$emit('busca-consultas-coletivas');
            this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Consulta coletiva agendada com sucesso!' });
          }
        } catch (err) {
          this.$root.$emit('requestError', err);
        } finally {
          this.loading = false;
        }
      }
    },
    fechaDialogLimpaForm() {
      this.form.id = null;
      this.form.dataInicio = '';
      this.form.horaInicio = '';
      this.form.dataFim = '';
      this.form.horaFim = '';
      this.pacientesSelecionadas = [] as Paciente[];
      this.formConsultaColetiva.resetValidation();
      this.dialog = false;
    },
    exibeResumoPaciente(paciente) {
      this.pacienteSelecionada = paciente;
      this.dialogResumoPaciente = true;
    },
  },
  watch: {
    inputDataInicio(novoValor) {
      if (novoValor.length > 0 && this.form.id === null) {
        this.form.dataFim = novoValor;
      }
    },
    inputHoraInicio(novoValor) {
      if (novoValor.length === 5 && this.form.id === null) {
        const pedacos = novoValor.split(':');
        this.form.horaFim = moment().hour(pedacos[0]).minute(pedacos[1]).add(2, 'hours')
          .format('HH:mm');
      }
    },
  },
});
